// Copyright (c) 2016 Deere & Company

import KeyValuePair from './key-value-pair';
import t from 'tcomb';

const PartReturnStatus = t.struct({
    allowedStatuses: t.list(KeyValuePair, 'AllowedReturnStatuses'),
    selectedStatuses: t.list(KeyValuePair, 'SelectedReturnStatuses')
}, {
    name: 'PartReturnStatus',
    strict: true
});

export const getDefaultState = () => new PartReturnStatus({
    allowedStatuses: [],
    selectedStatuses: []
});

export default PartReturnStatus;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/part-return-status.js